export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

// TODO
// Oggi lo standard industriale è sostituire quella funzione artigianale
// con una combinazione di due librerie leggerissime che risolvono ogni conflitto di Tailwind in modo automatico.
// import { clsx, type ClassValue } from 'clsx';
// import { twMerge } from 'tailwind-merge';

// export function cn(...inputs: ClassValue[]) {
//   return twMerge(clsx(inputs));
// }
